// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.77.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.77.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tabs_PJbHF {\n  height: 100%;\n}\n\n.tabPanel_cJAl9 {\n  background-color: #fff;\n  height: 100%;\n}", "",{"version":3,"sources":["webpack://./enabler/Tabs/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAEA;EACI,sBAAA;EACA,YAAA;AACJ","sourcesContent":[".tabs {\r\n    height: 100%;\r\n}\r\n\r\n.tabPanel {\r\n    background-color: #fff;\r\n    height: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": "tabs_PJbHF",
	"tabPanel": "tabPanel_cJAl9"
};
export default ___CSS_LOADER_EXPORT___;
